import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEn from './locales/en/common.json';
import dashboardEn from './locales/en/dashboard.json';
import municipalitiesEn from './locales/en/municipalities.json';
import usersEn from './locales/en/users.json';
import translationsEn from './locales/en/translations.json';
import settingsEn from './locales/en/settings.json';
import profileEn from './locales/en/profile.json';
import chatEn from './locales/en/chat.json';
import adminEn from './locales/en/admin.json';
import knowledgeBaseEn from './locales/en/knowledgeBase.json';
import userRolesEn from './locales/en/userRoles.json';

import commonEl from './locales/el/common.json';
import dashboardEl from './locales/el/dashboard.json';
import municipalitiesEl from './locales/el/municipalities.json';
import usersEl from './locales/el/users.json';
import translationsEl from './locales/el/translations.json';
import settingsEl from './locales/el/settings.json';
import profileEl from './locales/el/profile.json';
import chatEl from './locales/el/chat.json';
import adminEl from './locales/el/admin.json';
import knowledgeBaseEl from './locales/el/knowledgeBase.json';
import userRolesEl from './locales/el/userRoles.json';

const resources = {
  en: {
    common: commonEn,
    dashboard: dashboardEn,
    municipalities: municipalitiesEn,
    users: usersEn,
    translations: translationsEn,
    settings: settingsEn,
    profile: profileEn,
    chat: chatEn,
    admin: adminEn,
    knowledgeBase: knowledgeBaseEn,
    userRoles: userRolesEn,
  },
  el: {
    common: commonEl,
    dashboard: dashboardEl,
    municipalities: municipalitiesEl,
    users: usersEl,
    translations: translationsEl,
    settings: settingsEl,
    profile: profileEl,
    chat: chatEl,
    admin: adminEl,
    knowledgeBase: knowledgeBaseEl,
    userRoles: userRolesEl,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n; 